import type { LoomVideo } from '../../types';

export const isLoomVideo = (entity: any): entity is LoomVideo => entity.__typename === 'LoomVideo';

export const getLoomVideoLink = (video: LoomVideo): string | null => video?.videoUrl ?? null;
